import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteGroupLeads: (
  fetchContext: FetchContext,
  groupLeadId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, groupLeadId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/group-leads/${groupLeadId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete group leads'));
